// Auto-generated from old repo translations - do not edit by hand
const es: Record<string, string> = {
  'logo.white': 'newlogo200.png',
  'logo.whiteLarge': 'newlogo400.png',
  'logo.green': 'creaticodeword_en_300.png',
  'logo.greenLarge': 'creaticodeword_en_600.png',
  'logo.logo': 'en-logo.png',
  'WhyBanner.mainTitle': 'Por qué CreatiCode?',
  'WhyBanner.creativeTitle': 'Compatible con\nMIT Scratch',
  'WhyBanner.creativeContent':
    'Nuestra plataforma se basa en la versión de código abierto de MIT Scratch 3.0, con muchas características nuevas que lo hacen más productivo. Le resultará muy fácil comenzar',
  'WhyBanner.contactTitle': 'Lenguaje\n3D simplificado',
  'WhyBanner.contactContent':
    'Hemos diseñado un sistema de bloques fáciles de entender para la programación 3D, para que no tenga que aprender otro lenguaje de codificación o interfaz complejos.',
  'WhyBanner.focusTitle': 'Lecciones\na su propio ritmo',
  'WhyBanner.focusContent':
    'Ofrecemos microlecciones escalonadas con proyectos de práctica específicos, para que usted tome el control de su camino y ritmo de aprendizaje en función de su propio tiempo y disposición',
  'WhyBanner2.mainTitle': '¿Por qué programar en 3D?',
  'WhyBanner2.creativeTitle': 'Una experiencia\nsúper divertida',
  'WhyBanner2.creativeContent':
    'La creación de proyectos en 3D es como jugar, con mundos virtuales infinitamente grandes, objetos / personajes realistas, cámaras que se mueven libremente e interacciones atractivas del usuario',
  'WhyBanner2.contactTitle': 'Capacitación mental\ncompleta',
  'WhyBanner2.contactContent':
    'Trabajar en proyectos 3D desarrolla tanto el cerebro izquierdo (ciencias, matemáticas y razonamiento lógico) como el cerebro derecho (diseño creativo y razonamiento espacial).',
  'WhyBanner2.focusTitle': 'Futuras\nTecnologías',
  'WhyBanner2.focusContent':
    'La programación 3D sienta las bases para muchas tecnologías nuevas, como Metaverse (VR / AR / MR), Diseño asistido por computadora (CAD) e impresión 3D.',
  'WhyBanner3.mainTitle': '¿Por qué la IA?',
  'WhyBanner3.creativeTitle': 'Infinitas oportunidades\nde aprendizaje',
  'WhyBanner3.creativeContent':
    'La IA abre un mundo de oportunidades de aprendizaje. Desde conceptos básicos hasta técnicas avanzadas, los estudiantes pueden ampliar sus habilidades en un campo que evoluciona rápidamente.',
  'WhyBanner3.contactTitle': 'Impulsando a los\ninnovadores del futuro',
  'WhyBanner3.contactContent':
    'Aprender IA brinda a los estudiantes las herramientas para innovar, resolver problemas del mundo real e impulsar los avances tecnológicos.',
  'WhyBanner3.focusTitle': 'Comprender los desafíos\néticos',
  'WhyBanner3.focusContent':
    'Aprender IA ayuda a los estudiantes a comprender cuestiones éticas como el sesgo y la privacidad. También disipa el miedo a que la IA reemplace a las personas, al aclarar sus capacidades reales.',
  'VideoBannerTop.sectionTitle': 'CreatiCode en acción',
  'VideoBannerTop.creativeTitle': 'Zona de juegos Scratch 2D\nmejorada',
  'VideoBannerTop.contactTitle': 'Scratch 3D\nPatio de juegos',
  'VideoBannerTop.focusTitle': 'Plan de estudios\na su propio ritmo',
  'VideoBannerTop.creative.title': 'Zona de juegos Scratch 2D\nmejorada',
  'VideoBannerTop.creative.mediaLink': 'https://videos.creaticode.com/enhanced-2d-scratch-playground.mp4',
  'VideoBannerTop.contact.title': 'Scratch 3D\nPatio de juegos',
  'VideoBannerTop.contact.mediaLink': 'https://videos.creaticode.com/3d-scratch-playground.mp4',
  'VideoBannerTop.focus.title': 'Plan de estudios\na su propio ritmo',
  'VideoBannerTop.focus.mediaLink': 'https://videos.creaticode.com/self-paced-curriculum.mp4',
  'VideoBannerTop.creativeCN.title': 'Escribir programas 3D\ncon bloques Scratch',
  'VideoBannerTop.creativeCN.mediaLink': '//player.bilibili.com/player.html?aid=605135896&bvid=BV1m84y1y7kx&cid=892225349&page=1',
  'TopBanner.creaticode': 'CreatiCode',
  'TopBanner.Header': 'CreatiCode: 3D Para Todas',
  'TopBanner.BriefIntroduction.0': 'Herramientas de IA',
  'TopBanner.BriefIntroduction.1': 'Código y diseño',
  'TopBanner.BriefIntroduction.2': 'Proyectos con IA + 3D',
  'TopBanner.SignUpButton': 'REGISTRO GRATUITO',
  'TopBanner.menu': 'MENÚ',
  'TopBanner.NavBarButtons.games': 'JUEGOS',
  'TopBanner.NavBarButtons.courses': 'CURSOS',
  'TopBanner.NavBarButtons.dashboard': 'TABLERO',
  'TopBanner.NavBarButtons.myStuff': 'MIS COSAS',
  'TopBanner.NavBarButtons.leaderBoard': 'TABLA DE LIDERAZGO',
  'TopBanner.NavBarButtons.forum': 'FORO',
  'TopBanner.NavBarButtons.about': 'SOBRE',
  'TopBanner.NavBarButtons.contact': 'CONTACTO',
  'TopBanner.NavBarButtons.create': 'CREAR',
  'TopBanner.NavBarButtons.joinNow': 'REGISTRO GRATUITO',
  'TopBanner.NavBarButtons.logout': 'CERRAR SESIÓN',
  'TopBanner.NavBarButtons.signIn': 'INICIAR SESIÓN',
  'TopBanner.NavBarButtons.explore': 'EXPLORAR',
  'TopBanner.NavBarButtons.olympic': 'OLÍMPICO',
  'TopBanner.NavBarButtons.learn': 'APRENDER',
  'TopBanner.NavBarButtons.hourOfCode': 'TUTORIALES',
  'TopBanner.guideLine': 'Manejar: W/S/A/D\nDetenerse/Voltear: SPACE',
  'TopBanner.signIn': 'Iniciar sesión',
  'TopBanner.join': 'Unirse',
  'TopBanner.myStuff': 'Mis cosas',
  'TopBanner.slogan': 'CreatiCode: Codificación 2D + 3D con Scratch Blocks',
  'TopBanner.subtitle': 'Programación con IA y 3D simple, creativa y divertida.',
  'TopBanner.whatBody':
    'CreatiCode se basa en Scratch 3.0 con herramientas de IA y 3D pensadas para estudiantes. Pueden generar imágenes, recibir ayuda para programar y usar bloques de IA para agregar visión, voz, chat y otras funciones inteligentes a sus proyectos.\n\nCon lecciones guiadas y espacios creativos, pasan de una idea a un proyecto con IA sin aprender un lenguaje de programación complejo.',
  'Footer.Title.highlight': 'Destacar',
  'Footer.Title.contact': 'Contáctenos',
  'Footer.Title.community': 'Comunidad',
  'Footer.Title.connect': 'Mantente conectado',
  'Footer.Title.linkWithSocial': 'Enlace con Social',
  'Footer.Highlight.about-us': 'Sobre nosotros',
  'Footer.Highlight.contact': 'Contacto',
  'Footer.Highlight.create': 'Crear',
  'Footer.Highlight.explore': 'Explorar',
  'Footer.Highlight.founder-story': 'Historia del fundador',
  'Footer.Highlight.advisor-team': 'Equipo asesor',
  'Footer.Highlight.join-us': 'Únete a nosotros',
  'Footer.Highlight.forum': 'Foro',
  'Footer.Highlight.privacy-policy': 'Política de privacidad',
  'Footer.Highlight.tutorials': 'Tutoriales',
  'Footer.CopyRight': 'Reservados todos los derechos',
  'Footer.Title.mission': 'Misión',
  'Footer.mission': 'Capacitar a cada estudiante para crear, resolver problemas y dar vida a sus ideas con la IA.',
  'DashBoardHeader.NavBarButtons.dashboard': 'TABLERO',
  'DashBoardHeader.NavBarButtons.games': 'JUEGOS',
  'DashBoardHeader.NavBarButtons.courses': 'CURSOS',
  'DashBoardHeader.NavBarButtons.leaderBoard': 'TABLA DE LIDERAZGO',
  'DashBoardHeader.NavBarButtons.forum': 'FORO',
  'DashBoardHeader.NavBarButtons.about': 'SOBRE',
  'DashBoardHeader.NavBarButtons.contact': 'CONTACTO',
  'DashBoardHeader.NavBarButtons.create': 'CREAR',
  'DashBoardHeader.NavBarButtons.joinNow': 'REGISTRO GRATUITO',
  'DashBoardHeader.NavBarButtons.logout': 'CERRAR SESIÓN',
  'DashBoardHeader.NavBarButtons.admin': 'ADMINISTRACIÓN',
  'DashBoardHeader.NavBarButtons.signIn': 'ACCESO',
  'DashBoardHeader.NavBarButtons.teacher': 'PROFESOR',
  'DashBoardHeader.NavBarButtons.school': 'COLEGIO',
  'DashBoardHeader.NavBarButtons.migration': 'MIGRACIÓN',
  'DashBoardHeader.NavBarButtons.explore': 'EXPLORAR',
  'DashBoardHeader.NavBarButtons.olympic': 'OLÍMPICO',
  'DashBoardHeader.NavBarButtons.learn': 'APRENDER',
  'DashBoardHeader.NavBarButtons.hourOfCode': 'TUTORIALES',
  'DashBoardHeader.NavBarButtons.metrics': 'MÉTRICA',
  'DashBoardHeader.NavBarButtons.setting': 'AJUSTE',
  'DashBoardHeader.NavBarButtons.discounts': 'DESCUENTOS',
  'DashBoardHeader.NavBarButtons.support': 'APOYO',
  'UpperFooter.title': 'Empiece a aprender hoy',
  'UpperFooter.subTitle': 'y prepárate para el mundo de las IA mañana',
  'UpperFooter.joinButton': 'Pruebalo ahora',
  'ExampleProjects.title': 'Proyectos de ejemplo',
  'ExampleProjects.slides.rover.title': 'Mars Rover',
  'ExampleProjects.slides.rover.content': 'Un rover que puede desplegarse, moverse y girar sobre la superficie de Marte',
  'ExampleProjects.slides.rover.image': 'marsdemo1_600.gif',
  'ExampleProjects.slides.solar.title': 'Sistema solar',
  'ExampleProjects.slides.solar.content': 'Simulación de la rotación y el giro de los planetas del sistema solar.',
  'ExampleProjects.slides.solar.image': 'solar.gif',
  'ExampleProjects.slides.d3maze.title': 'Juego de laberintos',
  'ExampleProjects.slides.d3maze.content': 'Conducir un automóvil fuera de un laberinto de paredes',
  'ExampleProjects.slides.d3maze.image': '3dmazedemo.gif',
  'ExampleProjects.slides.d3walkway.title': 'Pasarela',
  'ExampleProjects.slides.d3walkway.content': 'Una pasarela flotante hecha de 3 ladrillos voladores',
  'ExampleProjects.slides.d3walkway.image': '3dwalkway.gif',
  'ExampleProjects.slides.magellan.title': 'La Expedición Magellan en 3D',
  'ExampleProjects.slides.magellan.content': 'Sigue la flota de Magellan para navegar alrededor del mundo',
  'ExampleProjects.slides.magellan.image': 'm2.gif',
  'ExampleProjects.slides.boymirror.title': 'Personajes animados',
  'ExampleProjects.slides.boymirror.content': 'Un niño jugando en un espejo enorme',
  'ExampleProjects.slides.boymirror.image': 'boy3.gif',
  'ExampleProjects.slides.d3bus.title': 'Autobús',
  'ExampleProjects.slides.d3bus.content': 'Un autobús con todas las funciones con ruedas, ventanas, puertas y luces',
  'ExampleProjects.slides.d3bus.image': 'busdemo.gif',
  'ExampleProjects.slides.ai.title': 'Jugadores de juegos de IA',
  'ExampleProjects.slides.ai.content':
    'Aprenda a jugar un juego manualmente, luego siga los tutoriales para crear un bot de juego que lo juegue automáticamente.',
  'ExampleProjects.slides.ai.image': 'MonkeyGame.gif',
  'ExampleProjects.slides.drawing.title': 'Geometría para dibujar',
  'ExampleProjects.slides.drawing.content':
    'Diseñe y dibuje imágenes interesantes con programas para adquirir conocimientos de programación y geometría al mismo tiempo',
  'ExampleProjects.slides.drawing.image': 'castle1.gif',
  'ExampleProjects.slides.algorithms.title': 'Algoritmos clásicos',
  'ExampleProjects.slides.algorithms.content':
    'Domine los algoritmos clásicos (por ejemplo, clasificación y búsqueda) a través de actividades desconectadas y simulaciones animadas.',
  'ExampleProjects.slides.algorithms.image': 'FootBallGame.gif',
  'ExampleProjects.slides.simulate.title': 'Simular aplicación real',
  'ExampleProjects.slides.simulate.content':
    'Cree prototipos de varias soluciones de IA del mundo real para comprender las aplicaciones básicas de IA.',
  'ExampleProjects.slides.simulate.image': 'PandaGame.gif',
  'ExampleProjects.slides.introducing.title': 'Introducción a los algoritmos de IA',
  'ExampleProjects.slides.introducing.content': 'Implemente proyectos de IA simplificados para aprender modelos y algoritmos de IA.',
  'ExampleProjects.slides.introducing.image': 'NumberDrawingGame.gif',
  changeLanguage: 'Cambiar idioma',
};

export default es;
